import { Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { PinTableComponent } from 'src/app/pin-modules/pin-table-module/components/pin-table/pin-table.component';
import { VoterSearchAPIService } from '../../services/api/api.service';
import { UtilityService } from 'src/app/shared/utility.service';
import { SessionService } from 'src/app/common/services/session.service';
import { GLOBAL_CONSTANT } from 'src/app/common/constant/global.constant';
import * as fileSaver from "file-saver";
interface City {
  name: string;
  code: string;
}

@Component({
  selector: 'app-public-search-history',
  templateUrl: './public-search-history.component.html',
  styleUrls: ['./public-search-history.component.scss']
})
export class PublicSearchHistoryComponent implements OnInit {
  searchResultListConfig: any;
  searchResultListRes: any = [];
  searchResp: any[];
  downloadExcel: Object;

  constructor(
    private service: VoterSearchAPIService,
    private us: UtilityService,
    private ss: SessionService
  ) {
  }


  getSearchResultListSearchViewConfig() {
    this.service.getHistorySearchListSearchViewConfig().subscribe((res) => {
      this.searchResultListConfig = res;
      this._init();
    });
  }

  handleEvent(event) {
    if (event.name == "LAZY_LOAD") {
      let page = this.us.PaginationPerPage(event.event);
      this.publicSearchHistory({page:page});
    }
  }

  ngOnInit() {
    this.getSearchResultListSearchViewConfig();
    let userInfo = this.ss.getUserInfo();
  }

  private publicSearchHistory(payload){
    this.service.publicSearchHistory(payload).subscribe((resp: any) => {
      console.log(resp, "resp");
       this.searchResp = resp;
     });
   }
  
  private _init() {
    let payload  = {
      page: {
        number: 0,
        size: 10,
      },
    };
    this.publicSearchHistory(payload);
  }
  downloadFile(){
    this.service.downloadExcelSearchHistory().subscribe(
      (resp: any) => {     
        console.log(resp);   
        var blob = new Blob([resp], { type: "text/plain;charset=utf-8" });
        fileSaver.saveAs(blob, "Report.csv");  
      },
      (error) => {}
    );

    this.service.downloadExcelSearchHistory().subscribe
  }
}
